import React from "react";
import { useSelector } from "react-redux";
import { useQueryClient } from "@tanstack/react-query";
import { Paper } from "@mui/material";

import TradedAccountsList from "../../../FundedTrader/components/TradedAccountsList";
import { ITradedAccount } from "../../../../api/funds/index.types";
import { checkIsCompletedAccount } from "../../../FundedTrader/utils";
import { FUNDED_COMPLIANCE_API_URLS } from "../../../../api/fundedCompliance";

const FundedAccounts: React.FC = () => {
  const queryClient = useQueryClient();
  const { mainData } = useSelector((state) => state.fundedComplianceProfile);

  const fundedAccounts: ITradedAccount[] = [];
  const priorAccounts: ITradedAccount[] = [];

  mainData.data.traded_accounts.forEach((account) => {
    if (
      checkIsCompletedAccount(
        account.processing_status,
        account.original_account,
        account,
        mainData.data.traded_accounts
      )
    ) {
      priorAccounts.push(account);
    } else {
      fundedAccounts.push(account);
    }
  });

  const handleRefresh = () => {
    queryClient.invalidateQueries({
      queryKey: [FUNDED_COMPLIANCE_API_URLS.traderProfile],
    });
  };

  return (
    <Paper
      sx={{
        p: "14px",
        backgroundColor: "#f2f2f2",
        mt: "20px",
        mb: "20px",
      }}
    >
      <TradedAccountsList
        fetchTradedAccounts={() => {
          handleRefresh();
          return Promise.resolve();
        }}
        title="Funded accounts"
        listItems={fundedAccounts}
        priorAccounts={priorAccounts}
      />

      <TradedAccountsList
        withCollapse
        fetchTradedAccounts={() => {
          handleRefresh();
          return Promise.resolve();
        }}
        title="Prior accounts"
        listItems={priorAccounts}
        priorAccounts={fundedAccounts}
      />
    </Paper>
  );
};

export default FundedAccounts;
